import { render, staticRenderFns } from "./PICPiani.vue?vue&type=template&id=40a1e1b6&scoped=true"
import script from "./PICPiani.vue?vue&type=script&lang=js"
export * from "./PICPiani.vue?vue&type=script&lang=js"
import style0 from "./PICPiani.vue?vue&type=style&index=0&id=40a1e1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a1e1b6",
  null
  
)

export default component.exports